import { Key, storage } from '@soluto-private/mx-context';

import type { Settings } from './types';
import isPartnerLocalizable from './localization/isPartnerLocalizable';
import localeToExpertise from './localization/localeToExpertise';

const initialSettings: Settings = {};

const getLocalizationSettings = () => {
    const settings: Settings = {};
    const partner = storage.get(Key.Client);

    if (isPartnerLocalizable(partner)) {
        const language = storage.get(Key.Language);
        const localeExpertise = localeToExpertise(language);
        settings.expertiseByTag = { ['language']: [localeExpertise] };
        settings.language = language;
    }

    return settings;
};

export const getDefaultSettings = (): Settings => {
    const settings = { ...initialSettings, ...getLocalizationSettings() };

    return settings;
};

export const SDK_SCRIPT_ID = 'one-service-ae-sdk-script';
export const getSDKUrl = (appKey: string) =>
    `https://assets.ae-sdk.io/core/v3/?appKey=${appKey}`;
